import {RouteConfig} from 'vue-router/types/router';

/**
 * Öffentliche Seiten der DSGVO-Löschung im Bewerbungs-Bereich (ohne Login):
 * - Bestätigung nach dem Antrag (die Person ist dann schon abgemeldet)
 * - Widerruf über den signierten Link der Bestätigungs-Mail (`<id>.<token>` als ein Pfad-Segment)
 */
export const applicantDeletionRoutes: RouteConfig[] = [
    {
        path: '/account-deletion-requested',
        name: 'Löschung beantragt',
        component: () => import(/* webpackChunkName: "applicant-deletion-public" */ '@/views/public/ApplicantDeletionRequestedView.vue'),
        meta: {
            forAll: true,
            answerPage: true,
            hideNavbar: true,
        },
    },
    {
        path: '/account-deletion/:ref',
        name: 'Löschung stoppen',
        component: () => import(/* webpackChunkName: "applicant-deletion-public" */ '@/views/public/ApplicantDeletionRevokeView.vue'),
        meta: {
            forAll: true,
            answerPage: true,
            hideNavbar: true,
        },
    },
];
